import { createAsyncTypes } from 'utils/ActionCreator'

export const DATA_REQUEST_ASYNC = createAsyncTypes(
  'DATA_REQUEST_ASYNC',
  'IronScales/Dashboard/Home/Campaigns'
)
